<template>
  <div class="feedback">
    <div class="txt">您的意见，是对我们最大的支持！</div>
    <van-form @submit="onSubmit" ref="validForm">
      <van-field
        v-model="feedbackInfo"
        placeholder="请输入"
        rows="5"
        type="textarea"
        :rules="[{ required: true, message: '' }]"
      />

      <div class="sumbit-btn" @click="onSubmit">提交</div>
    </van-form>
    <div class="back-btn" @click="$router.back()">返回</div>
  </div>
</template>

<script>
import { addOpinion } from '@/api/common/index.js'
import '@/assets/_variable.scss'
import { Toast } from 'vant'
export default {
  name: 'Feedback',
  data() {
    return {
      feedbackInfo: '',
    }
  },
  created() {},
  methods: {
    onSubmit() {
      this.$refs.validForm
        .validate()
        .then(() => {
          //do
          addOpinion({
            content: this.feedbackInfo,
          }).then((res) => {
            console.log(res)
            Toast.success('提交成功！')
            this.$router.push('/user/userCenter')
          })
        })
        .catch(() => {
          console.log('failed')
        })
    },
  },
  mounted() {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.feedback {
  width: 100%;
  padding: 20px 0;
  height: 100%;
  background: url('../../assets/img/notice-bg.png') top center no-repeat;
  background-size: contain;
  .txt {
    color: #403f45;
    font-size: 15px;
    font-weight: 400;
    padding: 0 20px;
    margin-bottom: 10px;
  }
  .van-form {
    margin: 0 20px;
    .van-cell {
      border: 1px solid #e6e6e6;
      border-radius: 6px;
      margin-bottom: 10px;
    }
    .sumbit-btn {
      margin-top: 30px;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #dd3349;
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      box-shadow: 0 0 15px #dd3349;
      border-radius: 4px;
      margin-bottom: 50px;
    }
  }
}
</style>
